import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterList = styled<any, any>('ol', 'filterList', 'filterItemDropdown')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

FilterList.defaultProps = {
    maxHeight: '300px',
    overflowX: 'hidden',
    overflowY: 'auto',
};

export default FilterList;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterList.tsx